import React from "react";
import styled from "styled-components";
import { theme } from "@upsolve/ui";

const ChatIconWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 200px;
  height: 56px;
  background-color: ${theme.colors.brand[500]};
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background-color: ${theme.colors.brand[400]};
  }

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;
  }
`;

const IconText = styled.span`
  color: white;
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: bold;
  margin-right: 8px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const SparklesIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g
      transform="scale(-1, 1) translate(-24, 0)"
      stroke="white"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeWidth="2"
    >
      <path d="m15 2 .5387 2.39157c.457 2.02858 2.0411 3.61274 4.0697 4.0697l2.3916.53873-2.3916.53873c-2.0286.45696-3.6127 2.04107-4.0697 4.06967l-.5387 2.3916-.5387-2.3916c-.457-2.0286-2.0411-3.61271-4.0697-4.06967l-2.3916-.53873 2.3916-.53873c2.0285-.45696 3.6127-2.04112 4.0697-4.06969z" />
      <path d="m7 12 .38481 1.7083c.3264 1.4489 1.45794 2.5805 2.90689 2.9069l1.7083.3848-1.7083.3848c-1.44895.3264-2.58049 1.4579-2.90689 2.9069l-.38481 1.7083-.38481-1.7083c-.3264-1.449-1.45794-2.5805-2.90692-2.9069l-1.70827-.3848 1.70827-.3848c1.44898-.3264 2.58052-1.4579 2.90692-2.9069z" />
    </g>
  </svg>
);

const ChatIcon: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <ChatIconWrapper onClick={onClick}>
      <IconText>Debt Assistant</IconText>
      <SparklesIcon />
    </ChatIconWrapper>
  );
};

export default ChatIcon;
